import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[mwNotificationBannerActions]' })
export class MwNotificationBannerActionsDirective {
  constructor(public template: TemplateRef<any>) {}
}
